import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { CityService } from './services/city.service';
import { CityOnboardingComponent } from './city-onboarding/city-onboarding.component';
import { ThemeService } from './services/theme.service';
import { SeatHoldReleaseService } from './services/seat-hold-release.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CookieConsentComponent,
    CityOnboardingComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'my-app';

  /** Header, routes, footer only after user picks a city from the popup. */
  readonly showAppShell = signal(!!this.cityService.getSelectedCity());

  private citySub?: Subscription;

  constructor(
    private cityService: CityService,
    private themeService: ThemeService,
    _seatHoldRelease: SeatHoldReleaseService
  ) {}

  ngOnInit(): void {
    this.themeService.initTheme();
    this.showAppShell.set(this.cityService.getSelectedCity() != null);
    this.citySub = this.cityService.selectedCity$.subscribe((c) => {
      this.showAppShell.set(c != null);
    });
  }

  ngOnDestroy(): void {
    this.citySub?.unsubscribe();
  }
}
